// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-header {
  gap: 1rem;
}

mat-spinner {
  margin: 0 auto;
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/admin/application-settings/application-settings.component.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;AACF;;AAEA;EACE,cAAA;AACF","sourcesContent":[".section-header {\n  gap: 1rem;\n}\n\nmat-spinner {\n  margin: 0 auto;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
